<div>
  <app-benchmark-by-year-filters *ngIf="years"
                                 [years]="years"
                                 [categories]="categories"
                                 [countryCategory]="countryCategory"
                                 (loadCategories)="loadCategories($event)"
                                 (search)="searchData($event)">
  </app-benchmark-by-year-filters>
  <mat-divider></mat-divider>
  <app-benchmark-by-year-bar-chart *ngIf="data"
                                   [title]="text"
                                   [subtitle]="subtitle"
                                   [countryCategory]="countryCategory"
                                   [displayUnits]="displayUnits"
                                   [countryCodes]="countryCodes"
                                   [sort]="sort"
                                   [data]="data">
  </app-benchmark-by-year-bar-chart>
</div>
